import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { registerFontkit } from 'pdfmake-unicode'
import Logo from '../../../assets/images/ctt-logo.png'
import htmlToPdfmake from 'html-to-pdfmake'
import { transitosInternacionalesBase64 } from './transitosInternacionalesBase64'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fontkit = registerFontkit

const formatPrice = price => (isNaN(price) ? '-' : `${price.toFixed(2)}€`)
// Función para preparar los datos de cada tabla

const prepareTableData = ratesReport => {
  ratesReport.sort(
    (a, b) => a.shipping_type_display_order - b.shipping_type_display_order,
  )
  return ratesReport
    .map(shippingType => {
      const sortedZones = [...shippingType.zones].sort(
        (a, b) => a.zone_display_order - b.zone_display_order,
      )

      const numOfRows = shippingType.zones[0].base_prices.length

      const numOfColumns = sortedZones.length
      const LargeTable = numOfColumns >= 9 || numOfRows >= 18

      const tableCellStyle = LargeTable ? 'smallTableText' : undefined
      const stackMargin = LargeTable ? [0, 0, 0, 0] : [0, 5, 0, 10]

      const header = [
        { text: '', alignment: 'center', bold: true },
        ...sortedZones.map(zone => ({
          text: zone.zone_name,
          alignment: 'center',
          bold: true,
          style: 'tableHeader',
        })),
      ]

      const rows = shippingType.zones[0].base_prices.map(
        (priceRange, index) => {
          const row = [
            {
              text:
                index === shippingType.zones[0].base_prices.length - 1
                  ? 'Kg adic'
                  : `${priceRange[1]} Kg`,
              alignment: 'center',
              bold: true,
              style: tableCellStyle,
            },
          ]

          sortedZones.forEach(zone => {
            let priceText
            const price = zone.base_prices[index]?.[2]
            const isAdditionalBeforeLastRow =
              zone.base_prices[index]?.[3] === 'ADDITIONAL'
            const isAdditionalRow =
              index === shippingType.zones[0].base_prices.length - 1
            if (isAdditionalRow) {
              priceText = formatPrice(
                zone.base_prices[zone.base_prices.length - 1]?.[2],
              )
            } else if (isAdditionalBeforeLastRow) {
              priceText =
                index === shippingType.zones[0].base_prices.length - 1
                  ? formatPrice(price)
                  : '-'
            } else {
              priceText = price !== undefined ? formatPrice(price) : '-'
            }

            row.push({
              text: priceText,
              alignment: 'center',
              style: tableCellStyle,
            })
          })

          return row
        },
      )

      const table = {
        table: {
          headerRows: 1,
          widths: Array(header.length).fill('*'),
          body: [header, ...rows],
        },
        layout: 'lightHorizontalLines',
      }

      let marketingText = null
      if (shippingType.marketing_text) {
        const htmlContent = htmlToPdfmake(shippingType.marketing_text, {})
        if (htmlContent.length > 1 && htmlContent[1].text) {
          htmlContent[1].text[0].fontSize = 13
        }
        marketingText = {
          stack: htmlContent,
          margin: [0, 5, 0, 15],
        }
      }

      return {
        unbreakable: numOfRows >= 15 ? false : true,
        stack: [
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: shippingType.shipping_type_name,
                    style: 'tableTitle',
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
              fillColor: function (rowIndex, node, columnIndex) {
                return '#DF0624'
              },
            },
            margin: stackMargin,
          },
          table,
          marketingText,
          { text: '', margin: [0, 0, 0, 30] },
        ],
      }
    })
    .flat()
}

// Función para generar el PDF
const generateCustomPDF = (data, t, user, text) => {
  // Estilos
  const styles = {
    header: {
      fontSize: 25,
      bold: true,
      alignment: 'left',
      bottom: 0,
      margin: [10, 5, 0, 10],
    },
    logo: {
      alignment: 'center',
      margin: [-40, -40, 0, -15],
    },
    tableTitle: {
      fontSize: 20,
      bold: true,
      alignment: 'center',
      color: '#FFFFFF',
    },
    text: {
      fontSize: 10,
      italics: true,
      color: '#555',
    },
    subheader: {
      margin: [0, text ? 40 : -10, 40, 20],
      top: 0,
    },
    smallTableText: {
      fontSize: 10,
    },
    tableHeader: {
      fontSize: 11,
      wordBreak: 'break-word',
      maxWidth: 100,
    },
  }

  // Generación de las tablas
  const tables = prepareTableData(data.rates_report)

  const finalImage = {
    image: transitosInternacionalesBase64,
    width: 590,
    pageBreak: 'before',
    margin: [-60, -20, -10, -20],
  }

  let zoningText = null
  if (data.marketing_text_zonning) {
    zoningText = htmlToPdfmake(data.marketing_text_zonning, {})
  }
  // Definición del documento
  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [40, 125, 40, 60],
    info: {
      title: data.report_title,
    },
    header: [
      {
        margin: [20, 20, 20, 0],
        columns: [
          {
            width: '*',
            text: `${data.report_title}`,
            style: 'header',
          },
          !text
            ? {
                width: 'auto',
                image: Logo,
                fit: [200, 200],
                style: 'logo',
              }
            : null,
        ],
      },
      {
        columns: [
          {
            width: '*',
            text: '',
          },
          {
            width: 'auto',
            text: text ? text : `${user.webUserName} - ${user.clientCode}`,
            style: 'subheader',
          },
        ],
      },
    ],
    footer: function (currentPage, pageCount) {
      return {
        text: currentPage.toString() + ' de ' + pageCount,
        alignment: 'center',
        margin: [0, 10, 0, 0],
      }
    },
    content: [
      ...tables,
      finalImage,
      zoningText ? { stack: zoningText } : null,
    ].filter(Boolean),
    styles,
  }

  pdfMake.createPdf(docDefinition).open({}, window.open('', '_blank'))
}

export { generateCustomPDF }
